module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" THE HARVARD COMMON PRESS"), _c('br'), _vm._v("\n535 Albany Street"), _c('br'), _vm._v("\nBoston, Massachusetts 02118"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.harvardcommonpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.harvardcommonpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("© 2003 by Liz Scott"), _c('br'), _vm._v("\nAll rights reserved. No part of this publication may be reproduced or"), _c('br'), _vm._v("\ntransmitted in any form or by any means, electronic or mechanical, including"), _c('br'), _vm._v("\nphotocopying, recording, or any information storage or retrieval system, without"), _c('br'), _vm._v("\npermission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Printed in the United States of America"), _c('br'), _vm._v("\nPrinted on acid-free paper")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _c('br'), _vm._v("\nScott, Liz."), _c('br'), _vm._v("\nThe sober kitchen : recipes and advice for a lifetime of sobriety / Liz Scott."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v("\nIncludes bibliographical references and index."), _c('br'), _vm._v("\nISBN 1-55832-220-5 (hc : alk. paper)—ISBN 1-55832-221-3 (pbk : alk. paper)"), _c('br'), _vm._v("\n1. Cookery. 2. Alcoholism—Diet therapy. I. Title."), _c('br'), _vm._v("\nTX714.S3925 2003"), _c('br'), _vm._v("\n641.5'631—dc21")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("2003007557")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Special bulk-order discounts are available on this and other Harvard Common Press books."), _c('br'), _vm._v("\nCompanies and organizations may purchase books for premiums or resale, or may arrange a"), _c('br'), _vm._v("\ncustom edition, by contacting the Marketing Director at the address above.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Cover design by Night & Day Design"), _c('br'), _vm._v("\nCover photograph by Amos Chan"), _c('br'), _vm._v("\nInterior design by Ralph Fowler")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0